var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 140",
    d: "M13.9399 1.02002L4.12666 4.29111C3.93893 4.35369 3.94637 4.62174 4.13728 4.6738L14.4383 7.48317C14.4784 7.49411 14.521 7.49227 14.56 7.47788L23.4379 4.2071C23.6181 4.14068 23.6102 3.88306 23.4262 3.82786L14.0606 1.01819C14.0212 1.00635 13.979 1.00699 13.9399 1.02002Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 141",
    d: "M4 4.5L0.768198 7.27012C0.650165 7.37129 0.68763 7.56254 0.835111 7.6117L10.8724 10.9575C10.9496 10.9832 11.0346 10.9596 11.0875 10.8979L14 7.5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 142",
    d: "M14 7.5L16.905 10.8892C16.9616 10.9552 17.0544 10.9771 17.1345 10.9434L26.2259 7.11542C26.3568 7.06031 26.3901 6.89011 26.2897 6.78968L23.5 4M3.5 8.5V18.8558C3.5 18.9419 3.55509 19.0184 3.63675 19.0456L13.9352 22.4784C13.9772 22.4924 14.0227 22.4921 14.0645 22.4774L23.8661 19.0469C23.9463 19.0188 24 18.9431 24 18.8581V8.05263",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 143",
    d: "M14 22V8",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 144",
    d: "M13.5 5C13.5 5.27614 13.7239 5.5 14 5.5C14.2761 5.5 14.5 5.27614 14.5 5H13.5ZM13.5 1V5H14.5V1H13.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryOthers);
export default __webpack_public_path__ + "static/media/project-category-others.637cfab2.svg";
export { ForwardRef as ReactComponent };